<template>
    <div class="row">
        <div class="col-12">
            <div class="card animated fadeInUp faster">
                <div class="card-header text-center">
                    <h5 class="mb-0 font-weight-normal">Your SEPA Bank Transfer Details</h5>
                </div>
                <div class="card-body text-center">
                    <div class="mb-4">
                        <h5>BENEFICIARY:</h5>
                        <code>{{ setupResponse.data.details.bankName }}</code>
                    </div>
                    <div class="mb-4">
                        <h5>IBAN:</h5>
                        <code>{{ setupResponse.data.details.bankAccount }}</code>
                    </div>
                    <div class="mb-4">
                        <h5>BIC:</h5>
                        <code>{{ setupResponse.data.details.bankBic }}</code>
                    </div>
                    <div class="mb-4">
                        <h5>AMOUNT:</h5>
                        <code>{{ setupResponse.data.currency }} {{ setupResponse.data.amount }}</code>
                    </div>
                    <div>
                        <h5>REFERENCE:</h5>
                        <code>{{ setupResponse.data.details.transferReference }}</code>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row align-items-center">
                        <div class="col-md-6 col-lg-6 mb-4 mb-md-0 mr-md-0">
                            <a @click="back" href="javascript:void(0);" class="btn btn-text d-block d-md-inline-block px-0"><i class="fas fa-angle-left mr-3"></i> Cancel transfer</a>
                        </div>
                        <div class="col-md-6 col-lg-6 text-md-right">
                            <button class="btn btn-primary" v-b-modal.confirm-transfer>
                                I have sent my payment <i class="fas fa-angle-right ml-3"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <b-modal id="confirm-transfer" title="Confirm" centered button-size="sm" @ok="confirm">
                    <template #modal-ok>I've sent the payment</template>
                    <template #modal-cancel>Cancel</template>
                    Please confirm that you have transferred the full amount to the specified bank account before proceeding.
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "SetupResponseSepa",
        computed: {
            ...mapState({
                setupResponse: state => state.payment.setupResponse,
            })
        },
        methods: {
            confirm() {
                window.location.href = this.setupResponse.data.completeUrl;
            },
            back () {
                this.$store.commit('setSetupResponse', null);
            }
        }
    }

</script>
